import React, { type ReactNode } from 'react';
import { Box, xcss } from '@atlaskit/primitives';

type MenuListProps = {
	children: ReactNode;
};

type MenuListItemProps = {
	children: ReactNode;
	ariaLabel?: string;
};

/**
 *  The following are generic components to be used for wrapping related <MenuItem>s into lists
 *  in the top navigation dropdown menus to improve accessibility.
 *  These components are here just for convenience, as the underlying <ul>s and <li>s require a few css lines,
 *  and we don't want to increase code duplication.
 */

export const MenuList = ({ children }: MenuListProps) => (
	<Box as="ul" xcss={removeDefaultListStyles}>
		{children}
	</Box>
);

export const MenuListItem = ({ children, ariaLabel }: MenuListItemProps) => (
	<Box as="li" xcss={removeDefaultListStyles} aria-label={ariaLabel}>
		{children}
	</Box>
);

const removeDefaultListStyles = xcss({
	padding: 'space.0',
	margin: 'space.0',
});
